_collow.components.HomeHeader = class HomeHeader extends (
  _collow.components.Base
) {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.setChangingTitles();
  }

  /** changing the header title every 5 seconds based on input array */
  setChangingTitles = async () => {
    const arrayWords = this.params.titles.split(",");
    this.root.textContent = arrayWords[0];

    await Promise.all(
      arrayWords.map(async (word, index) => {
        await this.sleep(index * 5000);
        if (index == 0) return;
        const uppercasedWord = word.charAt(0).toUpperCase() + word.slice(1);
        this.root.textContent = uppercasedWord;
      })
    );
    // this.setChangingTitles();
    this.setChangingTitles();
  };

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
};
